
<div class="open-app" v-show="show">
  <div class="close" @click="show = !show">
    <img src="@/assets/student/closeX.png" alt="" />
  </div>
  <div class="logo">
    <img src="@/assets/usercenter/parentHandbook/logo.png" alt="" />
  </div>
  <div class="desc">打开美术宝1对1 APP</div>
  <div class="open" @click="openApp('h5', path)">
    <span>立即打开</span>
  </div>
</div>
